// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ceNb","content":"styles_content__Ldfb9"};